module.exports = __webpack_public_path__ + "cd6dc830eb45b3a5a96bbc936ff54846.png";